export default "__VITE_ASSET__02ee3d38__"